export default __webpack_public_path__ + "media/color/vet-5f1dca55.svg";